import { Page } from '../api/pagination/page'
import { Button } from '@ordr-as/umami-react'

interface Props<T extends object> {
    page: Page<T> | undefined
    onSwapPage: (pageNo: number) => void
}

const PaginationButtons = <T extends object>({ page, onSwapPage }: Props<T>) => {
    const hasNext = page && !page.isLast
    const hasPrev = page && !page.isFirst
    const pageNo = page?.currentPageNo || 0

    const i = page?.pageContent && page?.pageContent.length > 0 ? 1 : 0
    const startIndex = pageNo * (page?.pageSize || 0) + i
    const endIndex = startIndex + (page?.numberOfElements || 0)

    return (
        <div className="py-5 flex flex-col items-center">
            <span className="text-xs xs:text-sm text-grey-dark">
                {`Showing ${startIndex} to ${endIndex - 1} of ${page?.totalElements || '-'} entries`}
            </span>
            <div className="px-5 inline-flex mt-2 space-x-2">
                <Button kind="secondary" size="small" isDisabled={!hasPrev} onClick={() => onSwapPage(pageNo - 1)}>
                    Prev
                </Button>
                <Button kind="secondary" size="small" isDisabled={!hasNext} onClick={() => onSwapPage(pageNo + 1)}>
                    Next
                </Button>
            </div>
        </div>
    )
}

export default PaginationButtons
